/* 🤖 this file was generated by svg-to-ts */
export const siriusLockSimpleOpen: {
  name: 'lock_simple_open';
  data: string;
} = {
  name: 'lock_simple_open',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.144 3.019a2.625 2.625 0 0 1 4.481 1.856.75.75 0 0 0 1.5 0 4.125 4.125 0 0 0-8.25 0V7.5H4.5A1.5 1.5 0 0 0 3 9v10.5A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5V9a1.5 1.5 0 0 0-1.5-1.5H9.375V4.875c0-.696.277-1.364.769-1.856ZM4.5 9v10.5h15V9h-15Z" fill="currentColor"/></svg>`
};
